import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { MetricsDashboard } from "@/features/admin/components/metrics-dashboard";
import { PageContainer } from "@fleet/ui/page-container";

function AdminMetricsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <MetricsDashboard />
    </PageContainer>
  );
}

export const adminMetricsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/metrics",
  component: AdminMetricsPage,
});
